import padNumber from './pad-number';

export default function msToHumanTime(milliseconds = 0) {
  let seconds = parseInt((milliseconds / 1000).toFixed());
  let minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;
  let hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  return `${hours}:${padNumber(minutes)}:${padNumber(seconds)}`;
}

